<div *ngIf="isLoading" class="container">
  <div class="spinner-container" style="position: relative; text-align: center">
    <img
      src="assets/baguio-logo-gov.png"
      alt="homepage"
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 120px;
        z-index: 2;
      "
      class="dark-logo"
    />
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
      diameter="150"
      style="position: relative; z-index: 1"
    ></mat-progress-spinner>
  </div>
</div>

<div *ngIf="!isLoading" class="container">
  <div
    class="email-verification-card"
    [ngClass]="{ success: isSuccess, error: !isSuccess }"
  >
    <div class="status-indicator">
      <ng-container *ngIf="isSuccess; else errorIcon">
        <mat-icon style="color: white">check_circle</mat-icon>
      </ng-container>
      <ng-template #errorIcon>
        <mat-icon style="color: white">error</mat-icon>
      </ng-template>
    </div>
    <div class="message mt-5">
      <ng-container *ngIf="isSuccess; else errorTemplate">
        <p>Your email has been successfully verified!</p>
      </ng-container>
      <ng-template #errorTemplate>
        <p>There was an error verifying your email. Please try again.</p>
      </ng-template>

      <div class="mt-5">
        <button
          mat-raised-button
          color="primary"
          style="color: white"
          routerLink="/evaluator/sign-in"
        >
          Back to Login
        </button>
      </div>
    </div>
  </div>
</div>
